import { useState, useEffect } from "react";
import type { FeatureFlagName } from "@services/featureFlags/types";
import type { MsofficeApiClient } from "../msoffice/api/types";

// Module-level cache shared across all hook instances
let cachedFlags: Record<string, any> | null = null;
let fetchPromise: Promise<Record<string, any>> | null = null;
let registeredApiClient: MsofficeApiClient | null = null;

export function registerFeatureFlagApiClient(client: MsofficeApiClient) {
  registeredApiClient = client;
}

/**
 * Returns the feature flag's value when active, or null when inactive/missing.
 * Values can be any JSON type (boolean, string, number, object, etc).
 */
export function useFeatureFlag(name: FeatureFlagName): any {
  const [value, setValue] = useState<any>(null);

  useEffect(() => {
    if (!registeredApiClient) return;

    if (cachedFlags) {
      setValue(cachedFlags[name] ?? null);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = registeredApiClient
        .post<{ flags: Record<string, any> }>("/feature-flags/evaluate")
        .then((res) => {
          cachedFlags = res.flags;
          return res.flags;
        })
        .catch(() => ({}));
    }

    fetchPromise.then((flags) => setValue(flags[name] ?? null));
  }, [name]);

  return value;
}
